import { useContext } from "react"
import requestAxios from "./requestAxios";
import AppContext from "../Context/AppContext";


const infoSource = {
  Acreditados: {
    GetSingleAcreditado: async function (infoUs, AcreditadoId) {
      const { error, data } = await requestAxios({
        url: `Acreditados/getAcreditado?acreditadoId=${AcreditadoId}`,
        method: "get",
        token: infoUs.bearer_token,
        data: {},
      });
      if (error == "") return data;
      else return [];
    },
    GetNuevosDomicilios: async function (infoUs, AcreditadoId) {
      const { error, data } = await requestAxios({
        url: `Acreditados/getNuevosDomicilios?acreditadoId=${AcreditadoId}`,
        method: "get",
        token: infoUs.bearer_token,
        data: {},
      });
      if (error == "") return data;
      else return [];
    },
    getRegistrosAcreditado: async function (infoUs) {
      const { error, data } = await requestAxios({
        url: `Acreditados/getRegistrosAcreditado`,
        method: "get",
        token: infoUs.bearer_token,
        data: {},
      });
      if (error == "") return data;
      else return [];

    },
    getRegistrosAcreditadoBusqueda: async function (infoUs,obj) {
      const { error, data } = await requestAxios({
        url: `Acreditados/getRegistrosAcreditadoBusqueda`,
        method: "post",
        token: infoUs.bearer_token,
        data: obj,
      });
      if (error == "") return data;
      else return [];

    }
  },
  Demandas: {
    AllDemandas: async function (infoUs) {
      const { error, data } = await requestAxios({
        url: `Demandas/getEtapasAllDemandas`,
        method: "get",
        token: infoUs.bearer_token,
        data: {},
      });
      if (error == "") return data;
      else return [];
    },
    EtapasDemandas: async function (infoUs, demandaId) {
      const { error, data } = await requestAxios({
        url: `Demandas/getEtapasDemandas?demandaId=${demandaId}`,
        method: "get",
        token: infoUs.bearer_token,
        data: {},
      });
      if (error == "") return data;
      else return [];
    },
    SubEtapasDemandas: async function (infoUs, demandaId, etapaId) {
      const { error, data } = await requestAxios({
        url: `Demandas/getSubEtapasDemandas?demandaId=${demandaId}&etapaId=${etapaId}`,
        method: "get",
        token: infoUs.bearer_token,
        data: {},
      });
      if (error == "") return data;
      else return [];
    },
    GetArchivosDemanda: async function (infoUs, demandaId, etapaId) {
      const { error, data } = await requestAxios({
        url: `Demandas/getArchivosDemanda?demandaId=${demandaId}&etapaId=${etapaId}`,
        method: "get",
        token: infoUs.bearer_token,
        data: {},
      });
      if (error == "") return data;
      else return [];
    }
  },
  Gestores: {
    GetCurrentInfoGestor: async function (infoUs) {
      const { error, data } = await requestAxios({
        url: `Gestores/getCurrentGestor`,
        method: "get",
        token: infoUs.bearer_token,
        data: {},
      });
      if (error == "") return data;
      else return [];
    },
  },
  Reportes: {
    CarteraAsignada: async function (infoUs) {
      const { error, data } = await requestAxios({
        url: `Reporte/CarteraAsignada`,
        method: "get",
        token: infoUs.bearer_token,
        data: {},
      });
      if (error == "") return data;
      else return [];
    }
    ,
    PagosDelMes: async function (infoUs) {
      const { error, data } = await requestAxios({
        url: `Reporte/PagosDelMes`,
        method: "get",
        token: infoUs.bearer_token,
        data: {},
      });
      if (error == "") return data;
      else return [];
    }
    ,
    GetSingleAcreditado: async function (infoUs, acreditadoId) {
      const { error, data } = await requestAxios({
        url: `Reporte/GetAcreditado?acreditadoId=${acreditadoId}`,
        method: "get",
        token: infoUs.bearer_token,
        data: {},
      });
      if (error == "") return data;
      else return [];
    }, 
    RelacionAcreditados: async function (infoUs) {
      const { error, data } = await requestAxios({
        url: `Reporte/RelacionAcreditados`,
        method: "get",
        token: infoUs.bearer_token,
        data: {},
      });
      if (error == "") return data;
      else return [];
    }
    ,
    CasosJudiciales: async function (infoUs) {
      const { error, data } = await requestAxios({
        url: `Reporte/CasosJudiciales`,
        method: "get",
        token: infoUs.bearer_token,
        data: {},
      });
      if (error == "") return data;
      else return [];
    }
    ,
  }
};

export default infoSource;
